module.exports = __webpack_public_path__ + "static/media/21.41780536.jpg";